import styled from 'styled-components';

export const InfoIconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  margin-left: 1rem;
  cursor: pointer;
  color: ${({ theme }) =>
    theme?.palette?.text?.primary || '#111'};

  &:hover {
    color: ${({ theme }) =>
      theme?.palette?.primary?.main || '#4f46e5'};
  }
`;

export const InfoBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -8px;
  background: ${({ theme }) =>
    theme?.palette?.error?.main || '#dc2626'};
  color: #fff;
  font-size: 0.625rem;
  padding: 2px 6px;
  border-radius: 999px;
  font-weight: bold;
  box-shadow: 0 0 0 1px #fff;
`;

export const InfoIconRow = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;